<s11-user-icon [userUrl]="store.imageUrl()"></s11-user-icon>
